import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 获取当前角色
export function getCurrentRole() {
  return localStorage.getItem('currentRole') || 'guest';
}

// 根据当前角色获取token
export function getTokenByRole() {
  const currentRole = getCurrentRole();
  // 优先从命名空间获取token
  let token = localStorage.getItem(`${currentRole}_token`);
  
  // 如果没有找到，则尝试从通用token获取
  if (!token) {
    token = localStorage.getItem('token');
  }
  
  return token;
}

// 根据角色设置token
export function setTokenByRole(token, role) {
  localStorage.setItem(`${role}_token`, token);
}

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    const token = getTokenByRole();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码不是200，说明接口有问题，应该提示错误信息
    if (res.code !== 200) {
      Message({
        message: res.message || '系统错误',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未登录或token过期
      if (res.code === 401) {
        // 清除token并跳转到登录页
        const currentRole = getCurrentRole();
        localStorage.removeItem(`${currentRole}_token`);
        
        // 根据角色跳转到对应的登录页
        if (currentRole === 'admin') {
          router.push('/admin/login');
        } else if (currentRole === 'merchant') {
          router.push('/merchant/login');
        } else {
          router.push('/customer/login');
        }
      }
      return Promise.reject(new Error(res.message || '系统错误'))
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    Message({
      message: error.message || '系统错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service 